import { connect } from 'react-redux'
import { compose, lifecycle, withHandlers } from 'recompose';
import { reduxForm } from 'redux-form'
import { clearUser, fetchUser, newUser, inviteUser, persistUser, deleteUser } from '../store/actions/users';
import UserForm from '../components/userForm/UserForm';
import { withLoadingComponent, withErrorComponent } from '../components/loading';
import { withRouter } from 'react-router-dom';
import { withModalHandlersAndBranch } from '../hocs/ModalHoc';
import ConfirmDialog from '../components/dialog/ConfirmDialog';
import { authRedirect } from '../lib/utils';
import {resetCountryCustomerBranchesSearch} from '../store/actions/branchSearch'

const mapStateToProps = (state, ownProps) => {
    const useraccess = state.user.user?state.user.user.accessList:[];

    return {
        ...state.user,
        initialValues: {
            ...state.user.user,
            useraccess: useraccess
        },
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const userId = ownProps.match.params.userId;
    return {
        clearUser: () => {
            dispatch(clearUser())
        },
        fetchUser: () => {
            if('new' === userId) {
                dispatch(newUser())
            } else {
                dispatch(fetchUser(userId)).catch(authRedirect(ownProps))
            }
        },
        inviteUser: (username) => {
            dispatch(inviteUser(username));
        },
        onSubmit: (data) => {
            const user = {...data, accessList: [...data.useraccess]};
            dispatch(persistUser(user)).then(r => {
                ownProps.history.push(`/users`)
            });
        },
        deleteUser: (id) => {
            dispatch(deleteUser(userId)).then( () => {
            ownProps.history.push(`/users`)
        })},
        resetSearch: () => {
            dispatch(resetCountryCustomerBranchesSearch())
        },
    }
};

const lifecycleValue = {
    componentWillMount() {
        this.props.fetchUser();
    },
    componentWillUnmount() {
        this.props.clearUser()
    }
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withModalHandlersAndBranch({
        name: 'DeleteUser',
        modal: ConfirmDialog,
        handlers: {
            handleDeleteUser: ({deleteUser, closeModalDeleteUser, user: {id}}) => () => {
                deleteUser(id);
                closeModalDeleteUser();
            }
        }
    }),
    lifecycle(lifecycleValue),
    withErrorComponent,
    withLoadingComponent,
    reduxForm({form: 'userForm'}),
    withHandlers({
        onBackClick: props => () =>{alert("Back")}
    })
)(UserForm);



// WEBPACK FOOTER //
// ./src/containers/UserFormContainer.js